export const priceToDecimal = (price: number): number => {
  return +(price / 1000).toFixed(2);
};
